/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _classCallCheck, a as _createClass } from '../../../_chunks/dep-c6ef2029.mjs';
import { _ as _defineProperty } from '../../../_chunks/dep-fa22eda7.mjs';
import { i as isUndefined_1 } from '../../../_chunks/dep-9a7888c7.mjs';
import { i as isBoolean_1 } from '../../../_chunks/dep-44e322cb.mjs';
import { o as omit_1 } from '../../../_chunks/dep-ad4331e8.mjs';
import { g as get_1 } from '../../../_chunks/dep-154ff253.mjs';
import log from '../log/log.mjs';
import '../../../_chunks/dep-8a0ff305.mjs';
import '../../../_chunks/dep-34428f12.mjs';
import '../../../_chunks/dep-1c40d002.mjs';
import '../../../_chunks/dep-61150968.mjs';
import '../../../_chunks/dep-2a69909d.mjs';
import '../../../_chunks/dep-e9ff4ce8.mjs';
import '../../../_chunks/dep-c54c9f32.mjs';
import '../../../_chunks/dep-c24f5c5d.mjs';
import '../../../_chunks/dep-31d34e52.mjs';
import '../../../_chunks/dep-67e8723b.mjs';
import '../../../_chunks/dep-0bf03d55.mjs';
import '../../../_chunks/dep-5b5daf08.mjs';
import '../../../_chunks/dep-1f286011.mjs';
import '../../../_chunks/dep-3ced59c9.mjs';
import '../../../_chunks/dep-95049222.mjs';
import '../../../_chunks/dep-ac19a2b6.mjs';
import '../../../_chunks/dep-90d97bcb.mjs';
import '../../../_chunks/dep-c8679a16.mjs';
import '../../../_chunks/dep-939a74d6.mjs';
import '../../../_chunks/dep-e4f65bc4.mjs';
import '../../../_chunks/dep-45572c49.mjs';
import '../../../_chunks/dep-1aa18f5f.mjs';
import '../../../_chunks/dep-e09a06d8.mjs';
import '../../../_chunks/dep-07f3660d.mjs';
import '../../../_chunks/dep-0d3220b0.mjs';
import '../../../_chunks/dep-895678a0.mjs';
import '../../../_chunks/dep-b2bdc7b9.mjs';
import '../../../_chunks/dep-0f45a6e0.mjs';
import '../../../_chunks/dep-16b9f817.mjs';
import '../../../_chunks/dep-e40749a5.mjs';
import '../../../_chunks/dep-8b3be089.mjs';
import '../../../_chunks/dep-c40264c0.mjs';
import '../../../_chunks/dep-437754aa.mjs';
import '../../../_chunks/dep-6dbd6c24.mjs';
import '../../../_chunks/dep-25b8bf4b.mjs';

var nodeKey = "__tdesign_tree-node__";
var TreeNodeModel = /*#__PURE__*/function () {
  function TreeNodeModel(node) {
    _classCallCheck(this, TreeNodeModel);
    _defineProperty(this, nodeKey, void 0);
    this[nodeKey] = node;
  }
  _createClass(TreeNodeModel, [{
    key: "value",
    get: function get() {
      var node = this[nodeKey];
      return node.value;
    }
  }, {
    key: "label",
    get: function get() {
      var node = this[nodeKey];
      return node.label;
    }
  }, {
    key: "data",
    get: function get() {
      var node = this[nodeKey];
      return node.data;
    }
  }, {
    key: "actived",
    get: function get() {
      var node = this[nodeKey];
      return node.actived;
    }
  }, {
    key: "expanded",
    get: function get() {
      var node = this[nodeKey];
      return node.expanded;
    }
  }, {
    key: "checked",
    get: function get() {
      var node = this[nodeKey];
      return node.checked;
    }
  }, {
    key: "indeterminate",
    get: function get() {
      var node = this[nodeKey];
      return node.indeterminate;
    }
  }, {
    key: "loading",
    get: function get() {
      var node = this[nodeKey];
      return node.loading;
    }
  }, {
    key: "getLevel",
    value: function getLevel() {
      var node = this[nodeKey];
      return node.getLevel();
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      var node = this[nodeKey];
      return node.getIndex();
    }
  }, {
    key: "isFirst",
    value: function isFirst() {
      var node = this[nodeKey];
      return node.isFirst();
    }
  }, {
    key: "isLast",
    value: function isLast() {
      var node = this[nodeKey];
      return node.isLast();
    }
  }, {
    key: "isLeaf",
    value: function isLeaf() {
      var node = this[nodeKey];
      return node.isLeaf();
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(newData) {
      var node = this[nodeKey];
      return node.insertBefore(newData);
    }
  }, {
    key: "insertAfter",
    value: function insertAfter(newData) {
      var node = this[nodeKey];
      return node.insertAfter(newData);
    }
  }, {
    key: "appendData",
    value: function appendData(data) {
      var node = this[nodeKey];
      return node.append(data);
    }
  }, {
    key: "getPath",
    value: function getPath() {
      var node = this[nodeKey];
      var nodes = node.getPath();
      return nodes.map(function (item) {
        return item.getModel();
      });
    }
  }, {
    key: "getParent",
    value: function getParent() {
      var _node$parent;
      var node = this[nodeKey];
      return (_node$parent = node.parent) === null || _node$parent === void 0 ? void 0 : _node$parent.getModel();
    }
  }, {
    key: "getParents",
    value: function getParents() {
      var node = this[nodeKey];
      var nodes = node.getParents();
      return nodes.map(function (item) {
        return item.getModel();
      });
    }
  }, {
    key: "getRoot",
    value: function getRoot() {
      var node = this[nodeKey];
      var root = node.getRoot();
      return root === null || root === void 0 ? void 0 : root.getModel();
    }
  }, {
    key: "getSiblings",
    value: function getSiblings() {
      var node = this[nodeKey];
      var nodes = node.getSiblings();
      return nodes.map(function (item) {
        return item.getModel();
      });
    }
  }, {
    key: "getChildren",
    value: function getChildren(deep) {
      var node = this[nodeKey];
      var childrenModel = false;
      var children = node.children;
      if (Array.isArray(children)) {
        if (children.length > 0) {
          if (deep) {
            var nodes = node.walk();
            nodes.shift();
            childrenModel = nodes.map(function (item) {
              return item.getModel();
            });
          } else {
            childrenModel = children.map(function (item) {
              return item.getModel();
            });
          }
        } else {
          childrenModel = false;
        }
      } else if (isBoolean_1(children)) {
        childrenModel = children;
      }
      return childrenModel;
    }
  }, {
    key: "remove",
    value: function remove(value) {
      var node = this[nodeKey];
      if (!value) {
        node.remove();
        return;
      }
      var tree = node.tree;
      var targetNode = tree.getNode(value);
      if (!targetNode) {
        log.warnOnce("Tree", "`".concat(value, "` is not exist"));
        return;
      }
      var parents = targetNode.getParents();
      var parentValues = parents.map(function (pnode) {
        return pnode.value;
      });
      if (parentValues.indexOf(node.value) < 0) {
        log.warnOnce("Tree", "`".concat(value, "` is not a childNode of current node"));
        return;
      }
      targetNode.remove();
    }
  }, {
    key: "setData",
    value: function setData(data) {
      var node = this[nodeKey];
      var _data = omit_1(data, ["children", "value", "label", "disabled"]);
      var keys = node.tree.config.keys;
      var dataValue = get_1(data, (keys === null || keys === void 0 ? void 0 : keys.value) || "value");
      var dataLabel = get_1(data, (keys === null || keys === void 0 ? void 0 : keys.label) || "label");
      var dataDisabled = get_1(data, (keys === null || keys === void 0 ? void 0 : keys.disabled) || "disabled");
      if (!isUndefined_1(dataValue)) _data.value = dataValue;
      if (!isUndefined_1(dataLabel)) _data.label = dataLabel;
      if (!isUndefined_1(dataDisabled)) _data.disable = dataDisabled;
      Object.assign(node.data, _data);
      Object.assign(node, _data);
    }
  }]);
  return TreeNodeModel;
}();
function createNodeModel(node) {
  var model = new TreeNodeModel(node);
  return model;
}

export { TreeNodeModel, createNodeModel, nodeKey };
//# sourceMappingURL=tree-node-model.mjs.map
